import React from 'react'
import { SWRConfig } from 'swr'

import { reportErrorToPostHog, setGlobalTrackEvent, useAnalytics } from '../posthog'
import HttpStatusCode from '../../api/errors/HttpStatusCode'

type Props = { children: React.ReactNode }

const GlobalErrorHandler: React.FC<Props> = ({ children }) => {
  const { trackEvent } = useAnalytics()

  // Set global reference for fetcher to use
  React.useEffect(() => {
    setGlobalTrackEvent(trackEvent)
  }, [trackEvent])

  return (
    <SWRConfig value={{
      onError: (error) => {

        if (error.code >= HttpStatusCode.INTERNAL_SERVER_ERROR) {
          reportErrorToPostHog(error)
        }
      }
    }}>
      {children}
    </SWRConfig>
  )
}

export default GlobalErrorHandler
